/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type CateringRequestPreferredTruckVariables = Types.Exact<{
  id: Types.InputMaybe<Types.Scalars['Int']>
}>

export type CateringRequestPreferredTruck = {
  __typename: 'Query'
  truck: { __typename: 'Truck'; id: number; name: string; menuUrl: string }
}

export const CateringRequestPreferredTruckDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CateringRequestPreferredTruck' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'truck' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'menuUrl' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode

/**
 * __useCateringRequestPreferredTruck__
 *
 * To run a query within a React component, call `useCateringRequestPreferredTruck` and pass it any options that fit your needs.
 * When your component renders, `useCateringRequestPreferredTruck` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCateringRequestPreferredTruck({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCateringRequestPreferredTruck(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    CateringRequestPreferredTruck,
    CateringRequestPreferredTruckVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    CateringRequestPreferredTruck,
    CateringRequestPreferredTruckVariables
  >(CateringRequestPreferredTruckDocument, options)
}
export function useCateringRequestPreferredTruckLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CateringRequestPreferredTruck,
    CateringRequestPreferredTruckVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    CateringRequestPreferredTruck,
    CateringRequestPreferredTruckVariables
  >(CateringRequestPreferredTruckDocument, options)
}
export type CateringRequestPreferredTruckHookResult = ReturnType<
  typeof useCateringRequestPreferredTruck
>
export type CateringRequestPreferredTruckLazyQueryHookResult = ReturnType<
  typeof useCateringRequestPreferredTruckLazyQuery
>
export type CateringRequestPreferredTruckQueryResult = Apollo.QueryResult<
  CateringRequestPreferredTruck,
  CateringRequestPreferredTruckVariables
>
